import { DestroyRef, Directive, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SignalHolder } from './signal-holder';

export interface FocusableComponent {
  focus(scroll: boolean): void;
  blur(): void;
  isFocused(): boolean;
}

/** Implemented by components that decide for themselves whether they can be deactivated (nav-away guard). */
export interface CanComponentDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
}

/* eslint-disable @angular-eslint/prefer-inject */
@Directive()
export abstract class AbstractComponent<S>
  extends SignalHolder<S>
  implements FocusableComponent, CanComponentDeactivate
{
  protected destroyRef = inject(DestroyRef);

  protected constructor(initialState: S) {
    super(initialState);
  }

  public canDeactivate(): boolean | Observable<boolean> {
    return true;
  }

  public focus(scroll: boolean = false) {
    this.focusable()?.focus(scroll);
  }

  public blur() {
    this.focusable()?.blur();
  }

  public isFocused(): boolean {
    return this.focusable()?.isFocused() ?? false;
  }

  protected focusable(): FocusableComponent | undefined {
    return undefined;
  }
}
